import { z } from 'zod'

import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import { BidIdSchema } from '../unique-id.models.ts'
import { SurveyFeedbackSchema } from './common.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const [
  OpportunityToBidDeclinedByMakerReasons,
  OpportunityToBidDeclinedByMakerReasonSchema,
  OpportunityToBidDeclinedByMakerReasonEnum,
] = EnumBuilder(
  'cannot-make-deadline',
  'insufficient-budget',
  'not-taking-new-projects',
  'unclear-scope',
  'not-interested',
  'other'
)

export type OpportunityToBidDeclinedByMakerReason = ZodInfer<
  typeof OpportunityToBidDeclinedByMakerReasonSchema
>

export const OpportunityToBidDeclinedByMakerResponsesSchema =
  z.discriminatedUnion('reason', [
    z.object({
      reason: OpportunityToBidDeclinedByMakerReasonSchema.extract(['other']),
      feedback: SurveyFeedbackSchema,
    }),
    z.object({
      reason: OpportunityToBidDeclinedByMakerReasonSchema.exclude(['other']),
      feedback: SurveyFeedbackSchema.optional(),
    }),
  ])

export type OpportunityToBidDeclinedByMakerResponses = ZodInfer<
  typeof OpportunityToBidDeclinedByMakerResponsesSchema
>

export const OpportunityToBidDeclinedByMakerSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract([
    'opportunity-to-bid-declined-by-maker',
  ]),
  bidId: BidIdSchema,
  responses: OpportunityToBidDeclinedByMakerResponsesSchema,
})
